module.exports = __webpack_public_path__ + "assets/img/write.b7a4fedb.png";